module.exports = __webpack_public_path__ + "img/bgIcon_12.f2ab897e.png";